module.exports = __webpack_public_path__ + "img/undraw_true_love_cy8x.7dc28c4d.svg";